module.exports = __webpack_public_path__ + "media/wrong.06057987.wav";